import script from "./QueueTicketsBuyPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./QueueTicketsBuyPage.vue?vue&type=script&setup=true&lang=ts"

import "./QueueTicketsBuyPage.vue?vue&type=style&index=0&id=60482094&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60482094"]])

export default __exports__